import type { Texts } from '../useTexts'

export const createValidateCourierFilter = (
  texts: Texts,
  courierFilter: string[],
  type: uui.domain.rm.RouteManagerUserType,
) => {
  const noTerritoriesDefined = courierFilter.length === 0

  const courierFilterErrors = {
    id: 'courierFilterErrors',
    message: noTerritoriesDefined ? texts.errors.courierFilter.noTerritoriesDefined : undefined,
  }

  const courierFilterRequiredError = type === 'courier' && noTerritoriesDefined

  return {
    [courierFilterErrors.id]: courierFilterRequiredError ? courierFilterErrors : undefined,
  }
}
